// Shared across every Modal instance: each listens on `document`, so Escape must reach only the
// topmost dialog.
const openModals: symbol[] = []

export const useModalStack = () => {
  const modalId = Symbol('modal')

  return {
    isTopmostModal: () => openModals.at(-1) === modalId,
    pushOpenModal: () => {
      if (!openModals.includes(modalId)) openModals.push(modalId)
    },
    popOpenModal: () => {
      const index = openModals.indexOf(modalId)
      if (index !== -1) openModals.splice(index, 1)
    },
  }
}
